import { CloseIcon, ICON_SELECTOR, IconSize } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';
import { header5 } from '@ardoq/typography';
import { FlexBox } from '@ardoq/layout';
import styled from 'styled-components';

const SubsectionHeaderSpace = styled(FlexBox)`
  ${header5};
  color: ${colors.grey500};

  ${ICON_SELECTOR} {
    cursor: pointer;
    &:hover {
      color: ${colors.grey700};
    }
  }
`;

export const SIDEBAR_MENU_SUBSECTION_HEADER_SELECTOR =
  SubsectionHeaderSpace.toString();

type SidebarMenuSubsectionHeaderProps = {
  title: string;
  onClose?: VoidFunction;
};

export const SidebarMenuSubsectionHeader = ({
  title,
  onClose,
}: SidebarMenuSubsectionHeaderProps) => {
  if (!title) return null;
  return (
    <SubsectionHeaderSpace justify="space-between" align="center">
      <span>{title}</span>
      {onClose && (
        <CloseIcon iconSize={IconSize.MEDIUM} deprecated_onClick={onClose} />
      )}
    </SubsectionHeaderSpace>
  );
};
